export enum Step {
    AUTH_METHODS,
    AUTH_PWD = 'pwd',
    AUTH_SAML2 = 'saml2',
}
